import React from "react";
import ComingSoon from "@/Utility/ComingSoon/ComingSoon";

const BoardSettings = () => {
  return (
    <div className="bg-surface-primary border border-border-primary rounded-md shadow-sm p-6">
      <ComingSoon title="Board settings" />
    </div>
  );
};

export default BoardSettings;
